export default __webpack_public_path__ + "static/media/Exito.e7465de8.svg";